import { render, staticRenderFns } from "./AxaptaSalaryCard.vue?vue&type=template&id=4c3a697b"
import script from "./AxaptaSalaryCard.js?vue&type=script&lang=js&external"
export * from "./AxaptaSalaryCard.js?vue&type=script&lang=js&external"
import style0 from "./AxaptaSalaryCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports